export default __webpack_public_path__ + "static/media/airbnb.49a39449.png";